import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import { otherComplaintsKey } from "./SymptomModules";
import OtherSymptomInput from "./OtherSymptomInput";

const SymptomParams = ({
  symptomParams,
  setSymptomParams,
  category,
  onSymptomParamsSelected,
}) => {
  const { t } = useTranslation();
  const [sortedParams, setSortedParams] = useState([]);
  const [selectedParams, setSelectedParams] = useState([]);

  useEffect(() => {
    const updatedSelectedParams = symptomParams?.filter((param) =>
      selectedParams.some((p) => p?.term === param?.term),
    );

    setSortedParams(symptomParams?.sort((a, b) => {
      if (t(a.term) < t(b.term)) return -1;
      if (t(a.term) > t(b.term)) return 1;
      return 0;
    }));

    setSelectedParams(updatedSelectedParams);
  }, [symptomParams]);

  const checkRequiredFields = () => {
    return selectedParams.length > 0;
  };

  function handleSelectSymptomElem(e, param) {
    if (e.target.checked) {
      setSelectedParams((prevSelected) => [...prevSelected, param]);
    } else {
      setSelectedParams((prevSelected) =>
        prevSelected?.filter((p) => p?.term !== param?.term),
      );
    }
  }

  function handleAddNewOtherComplaints(symptom) {
    const updatedSymptoms = [...symptomParams, symptom];
    setSymptomParams(updatedSymptoms);

    setSelectedParams((prevSelected) => {
      if (!prevSelected.some((p) => p?.term === symptom?.term)) {
        return [...prevSelected, symptom];
      }

      return prevSelected;
    });
  }

  return (
    <div className="disease-tree symptom-params-dialog">
      <header className="w3-container w3-padding-small w3-center symptom-edit-header">
        <p className="symptom-params-title">{t("please_select_the_symptom_parameters")}</p>
      </header>
      {category === otherComplaintsKey && (
        <OtherSymptomInput
          onAddNewSymptomParam={handleAddNewOtherComplaints}
          symptomsList={symptomParams}
        />
      )}
      <div className="w3-container form-content-scroll symptom-edit-surface symptom-params-surface">
        {sortedParams?.map((elem, i) => {
          const label = t(elem.term);

          return (
            <div className="w3-container symptom-params-item" key={`elem${i}`}>
              <FormControlLabel
                sx={{
                  width: '100%',
                  justifyContent: 'flex-start',
                  marginLeft: 0,
                  marginRight: 0,
                }}
                label={<span className="symptom-params-label">{label}</span>}
                labelPlacement="end"
                control={
                  <Checkbox
                    sx={{
                      color: "#64a8d8",
                      "&.Mui-checked": {
                        color: "#1565a0",
                      },
                    }}
                    value={elem.term}
                    checked={selectedParams.some((p) => p.term === elem.term)}
                    onChange={(e) => handleSelectSymptomElem(e, elem)}
                  />
                }
              />
            </div>
          );
        })}
      </div>
      <footer className="w3-container symptom-edit-footer">
        <div className="w3-right symptom-edit-footer-actions w3-margin-right">
          <button
            onClick={() => onSymptomParamsSelected(selectedParams)}
            type="button"
            className="symptom-ui-button symptom-ui-button--solid-primary symptom-edit-submit-button"
            disabled={!checkRequiredFields()}
          >
            {t("submit")}
          </button>
        </div>
      </footer>
    </div>
  );
};

export default SymptomParams;
